// URL helpers for products and categories. They prefer the slug and fall back to
// the numeric id for data that predates slugs (e.g. carts saved before them).

export function productPath(product) {
    return `/product/${product?.slug || product?.id}`;
}

export function categoryParam(category) {
    return category?.slug || category?.id;
}

export function isNumericParam(value) {
    return /^\d+$/.test(String(value ?? ""));
}

export function findCategoryInTree(categories, predicate) {
    for (const category of categories || []) {
        if (predicate(category)) return category;

        const found = findCategoryInTree(category.children, predicate);
        if (found) return found;
    }

    return null;
}

// Turns a ?category= value (slug, or a legacy numeric id) into a category id.
// Returns undefined while a slug can't be resolved yet (category tree not loaded)
// and null when the tree is loaded but no category has that slug.
export function resolveCategoryParam(categories, value) {
    if (value == null || value === "") return null;
    if (isNumericParam(value)) return Number(value);
    if (!categories || categories.length === 0) return undefined;

    const category = findCategoryInTree(categories, (c) => c.slug === value);
    return category ? category.id : null;
}
